import { BlockReferenceArray } from '@/cms/types/block';
import { BlockComponentModel } from '@/cms/types/blok-component';

import { BlockHeader, BlockHeaderContent } from '@/cms/BlockHeaderContentDC';
import { ImageStrapiProps } from '@/decodo/components/atoms/Image/ImageStrapi';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import type { RichTextFieldStrapiProps } from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { AuthorStrapiProps } from '@/decodo/components/organisms/author/AuthorStrapi';
import { PostTopic } from '@/decodo/features/shared//BlogMetaData/PostTags';
import { BlockWrapper } from '@/cms/BlockWrapperDC';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';
import { BlogOverview } from '.';

export type MetadataStrapiProps = {
  slug: string;
  metadata: {
    image: ImageStrapiProps;
    releaseDate: string;
    timeSpentReading: number;
    newUntil?: string;
    title: string;
    description: RichTextFieldStrapiProps;
    topics: BlockReferenceArray<PostTopic>;
    author: AuthorStrapiProps['blogAuthor'];
  };
};
export interface BlogOverviewStrapiProps {
  articles: BlockReferenceArray<MetadataStrapiProps>;
  header?: BlockHeader;
  link?: LinkButtonStrapiProps;
}

export function BlogOverviewStrapi({
  block,
  ...rest
}: BlockComponentModel<BlogOverviewStrapiProps>) {
  if (!block) {
    return null;
  }

  return (
    <BlockWrapper {...rest} data-tracker-section={SECTION_NAMES.BLOG_OVERVIEW}>
      <div>
        <BlockHeaderContent {...block.header}>
          <BlogOverview
            articleSlugs={
              block?.articles?.data?.map(
                (article) => article.attributes.slug
              ) ?? []
            }
          />
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
